import { ChangeEvent } from 'react';

import { ReactComponent as ClipboardText } from 'assets/icons/ClipboardText.svg';

interface DescriptionAreaProps {
  value: string;
  onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  readOnly?: boolean;
  dataTestId?: string;
  maxLength?: number;
}

const DescriptionArea = ({ value, onChange, placeholder, readOnly, dataTestId, maxLength }: DescriptionAreaProps) => (
  <div className="flex items-start gap-2">
    <div className="flex shrink-0 items-center px-3">
      <ClipboardText className="h-6 w-6 stroke-gray-60 stroke-1.5" />
    </div>
    <textarea
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      readOnly={readOnly}
      maxLength={maxLength}
      tabIndex={readOnly ? -1 : 0}
      className={`min-h-[96px] w-full resize-none rounded-2xl border border-transparent bg-gray-10 px-4 py-3 text-size-md font-light text-black placeholder:text-gray-60 hover:border-primary-50 focus:border-primary-50 focus:outline-none focus:ring-transparent${
        readOnly ? ' pointer-events-none select-none' : ''
      }`}
      data-testid={dataTestId}
    />
  </div>
);

export default DescriptionArea;
